import { FOOTER_LINK } from "@config/link";
import routeConfig from "@config/routes";
import { Menu, OpenInNew } from "@mui/icons-material";
import { AppBar, Box, Button, Drawer, Hidden, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useLanguageHook from "containers/hooks/useLanguageHook";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import LanguageSelect from "../NavbarComponents/LanguageSelect";

function Header() {
  const location = useLocation();
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const closeDrawer = () => setDrawerOpen(false);
  const pathname = `/${location.pathname.replaceAll("/", "")}`;
  const { t } = useLanguageHook();

  return (
    <AppBar
      position="absolute"
      color="primary"
      sx={{
        zIndex: theme.zIndex.drawer + 1,
        position: "fixed",
        width: "100%",
        background: theme.palette.background.default,
        "@media print": {
          display: "none",
        },
      }}
    >
      <Toolbar variant="dense">
        <Hidden mdDown>{renderDesktopTabs()}</Hidden>
        <Hidden mdUp>
          <Button size="large" onClick={() => setDrawerOpen(!drawerOpen)}>
            <Menu />
          </Button>
          <Typography
            variant="h5"
            sx={{
              paddingLeft: "1em",
              textTransform: "initial",
              fontWeight: 900,
            }}
          >
            {t.UI.TransparencyVis}
          </Typography>
          <Drawer
            sx={{
              width: "300px",
              zIndex: theme.zIndex.drawer + 2,
            }}
            anchor={"top"}
            open={drawerOpen}
            onClose={closeDrawer}
          >
            {renderMobileDrawer()}
          </Drawer>
          <Box sx={{ flexGrow: 1 }} />
          <LanguageSelect collapsed />
        </Hidden>
      </Toolbar>
    </AppBar>
  );

  function renderMobileDrawer() {
    return (
      <React.Fragment>
        <Button
          component={Link}
          size="large"
          sx={{ color: theme.palette.text.primary }}
          onClick={closeDrawer}
          to={routeConfig.Root}
        >
          {t.UI.About}
        </Button>
        <Button
          component={Link}
          size="large"
          sx={{ color: theme.palette.text.primary }}
          onClick={closeDrawer}
          to={routeConfig.Application}
        >
          <Typography
            sx={{
              paddingLeft: "1em",
              textTransform: "initial",
              fontWeight: 900,
            }}
          >
            {t.UI.TransparencyVis}
          </Typography>
        </Button>
        <Button
          component={Link}
          size="large"
          sx={{ color: theme.palette.text.primary }}
          onClick={closeDrawer}
          to={routeConfig.Imprint}
        >
          {t.UI.Imprint}
        </Button>
        <Button
          component={Link}
          size="large"
          sx={{ color: theme.palette.text.primary }}
          onClick={closeDrawer}
          to={routeConfig.Dsgvo}
        >
          {t.UI.PrivacyPolicy}
        </Button>
        <Button
          component={Link}
          size="large"
          to={FOOTER_LINK}
          target="_blank"
          rel="noopener"
          disableRipple
          sx={{ color: theme.palette.text.primary }}
        >
          &copy; {new Date().getFullYear()} Fraunhofer IGD
          <OpenInNew />
        </Button>
      </React.Fragment>
    );
  }

  function renderDesktopTabs() {
    return (
      <Tabs
        sx={{
          width: "100%",
          display: "flex",
          "& div.MuiTabs-flexContainer": {
            width: "100%",
          },
        }}
        centered
        value={pathname}
      >
        <Tab
          sx={{ color: theme.palette.text.primary, paddingY: 0 }}
          component={Link}
          label={t.UI.About}
          to={routeConfig.Root}
          value={routeConfig.Root}
        />
        <Tab
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 900,
            paddingY: 0,
          }}
          component={Link}
          label={t.UI.TransparencyVis}
          to={routeConfig.Application}
          value={routeConfig.Application}
        />
        <Tab
          label=""
          disabled
          sx={{
            flexGrow: 1,
            [theme.breakpoints.down("lg")]: { display: "none" },
          }}
        />
        <LanguageSelect slim />
        <Tab
          value=""
          sx={{ paddingY: 0 }}
          label={
            <Button
              component={Link}
              to={FOOTER_LINK}
              target="_blank"
              rel="noopener"
              disableRipple
              sx={{ color: theme.palette.text.primary, textTransform: "initial" }}
              endIcon={<OpenInNew fontSize="small" />}
            >
              &copy; {new Date().getFullYear()} Fraunhofer IGD
            </Button>
          }
        />
      </Tabs>
    );
  }
}

export { Header };
